import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { CreateContentPopup } from './CreateContentPopup';

const POPUP_KEY = Symbol('CREATE_CONTENT');

/**
 * Open the "create content" popup
 * @returns {function(): Promise<null>}
 */
export const useCreateContentPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, CreateContentPopup);
  });

  return useCallback(() => {
    return new Promise((resolve) => {
      popups.openPopup(POPUP_KEY, {
        onClose: () => {
          popups.closePopup(POPUP_KEY);
          resolve();
        },
      });
    });
  }, [popups]);
};
